import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';

@Component({
  selector: 'wl-horizontal-commodity-offer-footer',
  templateUrl: './horizontal-commodity-offer-footer.component.html',
  styleUrls: [
    './horizontal-commodity-offer-footer.component.ed.scss',
    './horizontal-commodity-offer-footer.component.essent.scss',
  ],
  standalone: true,
  imports: [RichTextWrapperComponent, CommonModule],
})
export class HorizontalCommodityOfferFooterComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contactInformation?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() productBenefits?: string;
}
